"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCancellablePromise;

var _react = require("react");

function makeCancelable(promise) {
  var isCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return isCanceled ? reject(new Error({
        isCanceled: isCanceled
      })) : resolve(val);
    }).catch(function (error) {
      return isCanceled ? reject(new Error({
        isCanceled: isCanceled
      })) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCanceled = true;
    }
  };
}

function ensurePromise(p) {
  return p instanceof Promise || p.then ? p : Promise.resolve(p);
}

function useCancellablePromise() {
  var cancelable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeCancelable;
  var emptyPromise = Promise.resolve(true); // test if the input argument is a cancelable promise generator

  if (cancelable(emptyPromise).cancel === undefined) {
    throw new Error('promise wrapper argument must provide a cancel() function');
  }

  var promises = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    promises.current = [];
    return function () {
      promises.current.forEach(function (p) {
        return p.cancel();
      });
      promises.current = [];
    };
  }, []);
  var cancellablePromise = (0, _react.useCallback)(function (p) {
    var cPromise = cancelable(ensurePromise(p));
    promises.current.push(cPromise);

    cPromise.promise.cancel = function () {
      cPromise.cancel();
    };

    return cPromise.promise;
  }, [cancelable]);
  return cancellablePromise;
}

useCancellablePromise.makeCancelable = makeCancelable;